module.exports = __webpack_public_path__ + "VAGRoundedStd-Thin.25fafd634717a91ab19b.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Thin.ttf
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Thin.ttf
// module chunks = styles